import { showAlert } from '../../../redux/slices/alert.slice';
import PrimaryButton from '../../atoms/Button';
import { ALERT_TYPE } from '../../molecules/Alert';
import Modal from '../../molecules/Modal/Modal';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { Checkbox } from '@mui/material';
import zubale from '../../../assets/img/png/Zubale Z 2023.png';
import { acceptZubaleTC } from '../../../services/zubale.service';

export const ShareInfoZubale = ({ onClose }: { onClose: () => void }) => {
	const dispatch = useDispatch();
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [showPdfModal, setShowPdfModal] = useState(false);
	const [acceptedTerms, setAcceptedTerms] = useState(false);
	const [selectedImage, setSelectedImage] = useState(false);

	const handleAcceptZubale = async () => {
		const body = {
			doc_type: 'T&Cs Zubale',
			version: '2024-09-05',
		};
		try {
			await acceptZubaleTC(body);
			const alert = {
				type: ALERT_TYPE.SUCCESS,
				title: '¡Listo!',
				description: 'Tu información fiscal ha sido compartida con Zubale',
			};
			dispatch(showAlert(alert));
			onClose();
		} catch (error) {
			const alert = {
				type: ALERT_TYPE.ERROR,
				title: 'Error',
				description: 'Ocurrió un error al compartir tu información fiscal',
			};
			dispatch(showAlert(alert));
		}
	};

	const handleOpenPdf = () => {
		setShowPdfModal(true);
	};

	if (showConfirmation) {
		return (
			<div>
				<p className='text-lg font-bold'>Zubale</p>
				<p className='mb-8'>
					Al aceptar terminos y condiciones, tu información fiscal será
					compartida.
				</p>
				<div className='flex  items-center ml-[-12px] mt-[-20px] mb-4 gap-1'>
					<Checkbox
						checked={acceptedTerms}
						onClick={() => setAcceptedTerms(!acceptedTerms)}
						sx={{
							'&.Mui-checked': {
								color: 'var(--h-primary)',
							},
						}}
					/>
					<div className='block w-full font-light'>
						Acepto los{' '}
						<span
							onClick={handleOpenPdf}
							style={{
								color: 'var(--h-primary)',
								textDecoration: 'underline',
								cursor: 'pointer',
							}}
						>
							Términos y Condiciones
						</span>
					</div>
				</div>
				<Modal
					open={showPdfModal}
					onClose={() => setShowPdfModal(false)}
					sx={'w-[96%] max-w-lg h-[90dvh] !p-2'}
				>
					<iframe
						src='https://noticias.heru.app/en/articles/4878081'
						width='100%'
						height='100%'
						title='Términos y Condiciones'
					></iframe>
				</Modal>
				<PrimaryButton
					disabled={!acceptedTerms}
					label='Compartir'
					onClick={handleAcceptZubale}
				/>
			</div>
		);
	}

	return (
		<div>
			<p className='text-lg font-medium'>Organizaciones</p>
			<p className='text-sm md:text-base font-light'>
				Selecciona una organización para compartir tu información fiscal:
			</p>

			<img
				src={zubale}
				alt='subale'
				className={`p-4 rounded-lg cursor-pointer mb-8 mt-4 w-20 h-20 border ${selectedImage ? 'border-blue-400' : 'border-gray-300'}`}
				onClick={() => setSelectedImage(!selectedImage)}
			/>

			<PrimaryButton
				onClick={() => setShowConfirmation(true)}
				disabled={!selectedImage}
				label='Continuar'
			/>
		</div>
	);
};
